module.exports = __webpack_public_path__ + "img/c07_unitbard_Normal_ua.b9dd2045.webp";